export const CHART = {
  navy: '#14305C',
  digital: '#2F6DB5',
  local: '#9CC0E6',
  accent: '#E8692A',
  grid: '#E8ECF1',
  axis: '#5A6A80',
  muted: '#8593A6',
};

export const AOP_PALETTE = ['#2F6DB5', '#E8692A', '#3F8F6B', '#7A5AC8'];
